import {Card, CardContent} from '@/components/ui/card'
import {FileTextIcon} from 'lucide-react'
import {useCalculator, KPI_NASTUPY} from '@/contexts/CalculatorContext'

export function ContractsBonusCard() {
    const {
        contracts,
        nastupy,
        getContractsBonus,
        calculate3ContractProfit,
        getContractsColor,
        getCardAnimation
    } = useCalculator()

    return (
        <Card
            className={`transition-all duration-300 border-2 ${getContractsColor(contracts)} ${getCardAnimation(3)} relative`}>
            <CardContent className="pt-6">
                <div className="space-y-3">
                    <div className="flex items-center gap-2">
                        <FileTextIcon className={`w-4 h-4 ${
                            contracts >= 1 ? 'text-green-500' :
                                'text-orange-500'
                        }`}/>
                        <span className="font-medium">3. složka <span className="text-xs">(za 6 měsíců)</span></span>
                        {contracts >= 1 ? (
                            <span className="text-xs text-green-500 font-medium">
                Dílčí KPI Splněno! ✓
              </span>
                        ) : (
                            <span className="text-xs text-orange-500 text-muted-foreground">
                                {contracts < 1 ? `Chybí 1 smlouva` :nastupy < KPI_NASTUPY ? `Chybí ${KPI_NASTUPY - nastupy} nástupů` : 'KPI nesplněno'}
                            </span>
                        )}
                    </div>
                    <div className="space-y-2">
                        <div className="flex justify-between items-center w-full">
              <span className="text-xs text-muted-foreground">
                {nastupy < KPI_NASTUPY ? (
                    "Bonus systém není aktivní"
                ) : (
                    `${contracts} NAS × ${getContractsBonus(contracts).toLocaleString()} Kč`
                )}
              </span>
              <span className="text-2xl font-bold">
                {nastupy < KPI_NASTUPY ? "0 Kč" : calculate3ContractProfit().toLocaleString() + " Kč"}
              </span>
                        </div>
                        <div className="w-full pt-2 border-t">
                            <div className="text-xs text-muted-foreground">
                                {contracts < 1 ?
                                    `Potřebujete ještě ${1 - contracts} smlouvu` :
                                    `Dílčí KPI splněno (${contracts} NAS)`}
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
} 